import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 1,
    paddingTop: 5,
    cursor: 'pointer',
    height: '100%',
    flexWrap: 'nowrap'
  },
  labelHeader: {
    paddingLeft: 3,
    marginBottom: 3,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-normal'
  },
  icon: { marginRight: 4, fontSize: 18, color: theme.palette.grey[500] },
  guestsInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: 40,
    marginLeft: 12
  },
  numberOfAdultsContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  numberOfRoomText: {
    height: '100%',

    display: 'flex',
    alignItems: 'center'
  },
  adultLabelContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    columnGap: 3,
    alignItems: 'center'
  },
  commaContainer: {
    height: '100%',
    marginRight: 5,
    // marginLeft: 5,
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    color: theme.palette.grey[500],
    alignItems: 'normal',
    fontWeight: 600
  },
  text: { fontWeight: 600, color: theme.palette.text.primary },
  number: { fontWeight: 600, marginRight: 4 }
}))
export default useStyles
